<div *ngIf="!displayMobileView" 
[ngClass]="{'content-table-pointer': checkPermission(row.id)}">
  <ion-row class="content content-table-pointer" (click)="editCompany(row.id)">
    <ion-col size="2">
      <ion-item lines="none" class="company-view__logo">
        <ion-avatar slot="start">
          <img
            class="company-view__logo-img"
            [src]="
              row.logo
                ? row.logo.filePath
                : '../../../assets/icons/company-plug.svg'
            "
          />
        </ion-avatar>
      </ion-item>
    </ion-col>

    <ion-col size="4">
      {{ row.name }}
    </ion-col>

    <ion-col size="6">
      {{ row.description }}
    </ion-col>
  </ion-row>
</div>

<ion-item *ngIf="displayMobileView" lines="full" (click)="editCompany(row.id)">
  <ion-avatar slot="start">
    <img
      class="company-view__logo-img"
      [src]="
        row.logo ? row.logo.filePath : '../../../assets/icons/company-plug.svg'
      "
    />
  </ion-avatar>
  <ion-label>
    <h2>{{ row.name }}</h2>
  </ion-label>
  <ion-icon
    name="chevron-forward"
    slot="end"
    *ngIf="checkPermission(row.id)"
  ></ion-icon>
</ion-item>